<section class="stc-venta-exitosa err-p banner-padding">
  <div class="container">
    <div class="row sub-headers-inside sub-inside">
      <div class="col-lg-6 col-md-12 my-auto text-lg-right order-lg-1 order-2" data-aos="fade-left"
        data-aos-easing="ease" data-aos-duration="3000">
        <img *ngIf="request.nbResponse != 'ErrorDatosCarrito'" src="/assets/img/sorteo2025/warning.png" alt="Error Pago"
          class="img-fluid m-auto d-lg-block d-none" width="300">
        <img *ngIf="request.nbResponse == 'ErrorDatosCarrito'" src="/assets/img/sorteo2025/boleto.png" alt="Error Pago"
          class="img-fluid m-auto d-lg-block d-none">

      </div>

      <div class="col-lg-6 col-md-12 text-center order-lg-2 order-1 my-auto">
        <h1
          *ngIf="request.nbResponse != 'ErrorDatosCarrito' && request.nbResponse != 'ErrorDatos' && request.nbResponse != 'CarritoDuplicado' && request.nbResponse != 'correoErroneo'">
          ERROR
          <span class="d-block">
            DE PAGO
          </span>
        </h1>

        <h1 *ngIf="request.nbResponse == 'ErrorDatosCarrito'">
          BOLETO
          <span class="d-block">
            BLOQUEADO
          </span>
        </h1>


        <h1 *ngIf="request.nbResponse == 'ErrorDatos'">
          ERROR AL
          <span class="d-block">
            ROTULAR BOLETO
          </span>
        </h1>

        <h1 *ngIf="request.nbResponse === 'CarritoDuplicado' || request.nbResponse === 'correoErroneo'  ">
          <span>ERROR</span>

        </h1>
      </div>

    </div>
  </div>
  <a (click)="scrollPage('#orden')" class="cta-bottom d-md-block d-none">
    <img src="/assets/img/sorteo2023/arrow-bottom.png" class="img-fluid">
  </a>
</section>

<section class="venta-ext">
  <div class="container" data-aos="fade-down" id="orden">

    <!-- Salida para quien venia de una liga de colaborador.
         Solo se pinta si hay liga: en una compra de venta digital no aparece, porque no
         habria a donde regresar. La liga sobrevive al limpiarCompra() del ngOnInit. -->
    <div class="row" *ngIf="ligaColaborador" style="margin-top:22px;">
      <div class="col-12">
        <div style="max-width:720px;margin:0 auto;padding:22px 24px;background:#fff8f4;border:1px solid #ffd7c2;border-left:5px solid #ff5900;border-radius:10px;text-align:left;">
          <h3 style="color:#2d2d6b;margin:0 0 8px;font-size:1.3rem;">
            Tus boletos siguen ahi
          </h3>
          <p style="color:#4a4a4a;font-size:1rem;margin:0 0 18px;line-height:1.5;">
            El pago no se completo, pero los boletos de
            <strong style="color:#eb4d10;">{{ nombreColaboradorLiga }}</strong>
            siguen disponibles. Puedes volver a verlos e intentar el pago de nuevo.
          </p>
          <button type="button" class="btn-stack" (click)="volverAMisBoletos()">
            Volver a mis boletos
          </button>
        </div>
      </div>
    </div>

    <div class="row bgerror" *ngIf="request.nbResponse != 'Aprobado' && reqBanamex.resultIndicator == undefined"
      data-aos="fade-down">
      <div class="BoletosPay col-xs-12 col-sm-12 col-md-12 col-lg-12 RechazadoC center space-top">
        <div>
          <h2
            *ngIf="request.nbResponse != 'ErrorDatosCarrito' && request.nbResponse != 'CarritoDuplicado'  && request.nbResponse != 'correoErroneo'"
            class="texto-primario errortitle" style="text-align: center">Transacción no exitosa</h2>
          <h2 *ngIf="request.nbResponse == 'ErrorDatosCarrito'" class="texto-primario errortitle"
            style="text-align: center;  font-size: 36px;"> Motivos de bloqueo</h2>
          <h2 *ngIf="request.nbResponse == 'CarritoDuplicado'" class="texto-primario
           errortitle" style="text-align: center;  font-size: 36px;"> ERROR CARRITO </h2>
          <h2 *ngIf="request.nbResponse == 'correoErroneo'" class="texto-primario
           errortitle" style="text-align: center;  font-size: 36px;"> ERROR EN EL CORREO </h2>
        </div>
        <div>

        </div>
        <div *ngIf="request.nbResponse == 'Rechazado'">
          <!-- <label style="text-align:center;">Lo sentimos, el pago por ${{request.importe}} MXN ha sido rechazado por su banco.</label>
              <label style="text-align:center;">Mensaje del banco: {{request.cdResponse}}</label>
              <label style="text-align:center;">" {{request.error}} "</label> -->
          <label>Lo sentimos, pago rechazado por su banco.</label>
        </div>

        <div *ngIf="request.nbResponse == 'Invalido'">
          <label class="errorlabel" style="text-align: center">Lo sentimos, uno o varios de sus boletos ya no se
            encontraban disponibles. Favor de intentar nuevamente</label>
        </div>

        <div *ngIf="request.nbResponse == 'Bloqueo'">
          <label class="errorlabel" style="text-align: center">Hubo un error al generar tu pago, por favor inténtalo
            nuevamente</label>
        </div>

        <div *ngIf="request.nbResponse == 'ErrorDatos'">
          <label class="errorlabel" style="text-align: center">Existe un problema con tus datos, ya que contienen
            caracteres no permitidos. Por favor, intenta de nuevo en 15 minutos, ya que tu boleto se encuentra en el
            carrito. Trata de no usar caracteres como '-?*/+, entre otros. </label>
        </div>
        <div *ngIf="request.nbResponse == 'ErrorDatosCarrito'">
          <label class="errorlabel" style="text-align: center">
            <ul>
              <li>
                El boleto ya contiene una orden compra en este caso hay que esperar 15 minutos, para que nuevamente
                intentes comprar el mismo número.
              </li>
              <li>
                Si generaste una referencia bancaria revisa que la tengas en tu correo y no olvides que esta se libera
                en 5 días hábiles
              </li>
            </ul>
          </label>
        </div>

        <div *ngIf="request.nbResponse == null">
          <label class="errorlabel">
            <ul>
              <li>
                Hubo un error al generar tu pago, por favor inténtalo nuevamente
              </li>

            </ul>

          </label>
        </div>

        <div *ngIf="request.nbResponse == 'CarritoDuplicado'">
          <label class="errorlabel" style="text-align: center"> Estás mezclando boletos de diferentes tipos o
            precios.<br>
            Solo puedes comprar boletos para egresados en esta sección.</label>
        </div>



        <div *ngIf="request.nbResponse == 'correoErroneo'">
          <label class="errorlabel" style="text-align: center">
            El correo electrónico proporcionado no es válido.<br>
            Debe ser el mismo correo que tienes registrado como egresado.
          </label>
        </div>


        <div class="col-xs-12 col-sm-12 margen-t center">
          <div class="row margen-t">
            <div class="col-12 margen-b center">
              <button (click)="terminar()" class="btn-stack border-0 mt-3">Volver a comprar</button>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
